"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lot = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const lot = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'lot-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M17 17.75V2.25C17 1.83579 16.6642 1.5 16.25 1.5H4.25C3.83579 1.5 3.5 1.83579 3.5 2.25V17.75C3.5 18.1642 3.83579 18.5 4.25 18.5H16.25C16.4489 18.5 16.6397 18.421 16.7803 18.2803C16.921 18.1397 17 17.9489 17 17.75ZM13.1998 10.5785L5.62122 3L15.5 3V8.29688L13.1998 10.5785ZM5 4.5001L12.1391 11.6392L6.77829 17H5L5 4.5001ZM15.4852 17H15.5V16.9852L15.4852 17ZM13.4999 17L11.1998 14.6999L8.89961 17H13.4999ZM12.2604 13.6392L15.5 10.3996V16.8788L12.2604 13.6392Z', fill: '#4B5563' })));
};
exports.lot = lot;
